export default __webpack_public_path__ + "static/media/logo.2e6b7498.svg";